import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import WelcomeBanner from "@components/common/WelcomeBanner";
import { Grid } from "@components/base";

interface PaygapWelcomeBannerInterface {}

const PaygapWelcomeBanner: FC<PaygapWelcomeBannerInterface> = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);

  const onClose = (): void => {
    setShow(false);
  };

  return show ? (
    <Grid size={12}>
      <WelcomeBanner
        color="purple"
        title={t("paygap.welcome.title")}
        text={t("paygap.welcome.text")}
        icon="data-cloud"
        onClose={onClose}
      />
    </Grid>
  ) : null;
};

export default PaygapWelcomeBanner;
